// 9fbef606107a605d69c0edbcd8029e5dsss
import { css } from 'styled-components';

const Styles = css`
  .promo-background-plcc {
    background: ${(props) => (props.isPlcc ? '#DBEBF8' : '#FEF4E8')} !important;
  }
  .promotion-plcc-pdp-text {
    font-size: 14px;
    color: #1a1a1a;
    font-weight: 600;
    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      font-size: 11px;
    }
  }
`;

export default Styles;
